import React, {useState} from "react";
import {Link} from "react-router-dom";
import PropTypes from 'prop-types';
import ROUTES from "../../route";
import Pagination from "../assets/Pagination";

const RenderBook = ({ books }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const booksPerPage = 9;

    const indexOfLastBook = currentPage * booksPerPage;
    const indexOfFirstBook = indexOfLastBook - booksPerPage;
    const currentBooks = books.slice(indexOfFirstBook, indexOfLastBook);

    const pageNumbers = [];
    for (let i=1; i <= Math.ceil(books.length / booksPerPage); i++ ) {
        pageNumbers.push(i)
    }

    const handleClick = (event, pageNumber) => {
        event.preventDefault();
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <>
            {currentBooks.map((book) => (
                <Link
                    key={book.id}
                    to={{pathname: ROUTES.GOOGLE_BOOK}}
                    state={{
                       books: books,
                       book:book
                    }}
                >
                    <div
                        className="bg-white shadow-md rounded-lg p-4 mb-4 flex"
                    >
                        <div className="flex">
                            {book.volumeInfo.imageLinks && book.volumeInfo.imageLinks.thumbnail && (
                                <img
                                    src={book.volumeInfo.imageLinks.thumbnail}
                                    alt={book.volumeInfo.title}
                                    className="thumbnail mr-4"
                                />
                            )}
                            <div>
                                <p className="text-lg font-semibold">{book.volumeInfo.title}</p>
                                <p className="text-gray-600">Author: {book.volumeInfo.authors ? book.volumeInfo.authors.join(', ') : 'N/A'}</p>
                                <p className="text-gray-600">Date of Publication: {book.volumeInfo.publishedDate || 'N/A'}</p>
                                <p className="text-gray-600">Genre: {book.volumeInfo.categories ? book.volumeInfo.categories.join(', ') : 'N/A'}</p>
                                <p className="text-gray-700">
                                    Description: {book.volumeInfo.description && book.volumeInfo.description.length > 250
                                    ? book.volumeInfo.description.substring(0, 247) + '...'
                                    : book.volumeInfo.description || 'N/A'}
                                </p>
                            </div>
                        </div>
                    </div>
                </Link>
            ))}
            <Pagination pageNumbers={pageNumbers} currentPage={currentPage} handleClick={handleClick}/>
        </>
    );
};

RenderBook.propTypes = {
    books: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            volumeInfo: PropTypes.shape({
                title: PropTypes.string.isRequired,
                authors: PropTypes.arrayOf(PropTypes.string),
                publishedDate: PropTypes.string,
                categories: PropTypes.arrayOf(PropTypes.string),
                description: PropTypes.string,
                imageLinks: PropTypes.shape({
                    thumbnail: PropTypes.string,
                }),
            }).isRequired,
        }).isRequired
    ).isRequired,
};

export default RenderBook;